@if (templateService(); as templates) {
  <soft-menu-bar-dropdown [label]="templateLabel()"
                          icon="fa-regular fa-bookmark"
                          [variant]="'outline'"
                          [hasValue]="!!templates.displayedActive()"
                          [responsive]="true"
                          data-testid="filter-menu-bar-templates">
    <!-- stopPropagation: the widget's softClickOutside treats overlay-panel clicks as outside and would close the menu -->
    <div *softMenuBarDropdownContent
         class="filter-menu-panel"
         (click)="$event.stopPropagation()"
         data-testid="filter-menu-bar-template-panel">
      @for (template of templates.sortedTemplates(); track template.id) {
        <button type="button"
                class="filter-menu-option"
                (click)="applyTemplate(template)"
                data-testid="filter-menu-bar-template-option">
          <span class="truncate">{{ template.name }}</span>
          @if (templates.displayedActive()?.id === template.id) {
            <soft-icon name="fa-regular fa-check" size="sm" class="filter-menu-check" />
          }
        </button>
      }
      @empty {
        <span class="ds-caption filter-menu-empty">{{ '#CORE_FILTER.TEMPLATES.EMPTY' | translate }}</span>
      }
      <div class="filter-menu-divider"></div>
      <button type="button"
              class="filter-menu-option"
              (click)="openTemplateManagement()"
              data-testid="filter-menu-bar-manage-templates">
        {{ '#CORE_FILTER.TEMPLATES.MANAGE' | translate }}
      </button>
    </div>
  </soft-menu-bar-dropdown>
}

@for (item of visibleItems(); track item.field) {
  @if (item.toggle) {
    <soft-menu-bar-button [label]="itemLabel(item)"
                          [icon]="item.config.icon"
                          [variant]="isToggleActive(item) ? 'primary' : 'outline'"
                          (execute)="toggleItem(item)"
                          data-testid="filter-menu-bar-toggle" />
  }
  @else {
  <soft-menu-bar-dropdown [label]="itemLabel(item)"
                          [icon]="item.config.icon"
                          [variant]="'outline'"
                          [hasValue]="service().getSourceItemValue(item) !== null"
                          data-testid="filter-menu-bar-item">
    <div *softMenuBarDropdownContent
         class="filter-menu-item-panel"
         (click)="$event.stopPropagation()"
         data-testid="filter-menu-bar-item-panel">
      <div class="filter-menu-item-content">
        @if (itemComponent(item); as component) {
          <ng-container *ngComponentOutlet="component; inputs: itemInputs(item)"></ng-container>
        }
      </div>
      <div class="filter-menu-item-footer">
        <soft-ds-button variant="primary" size="sm"
                        (click)="applyItem(item)"
                        data-testid="filter-menu-bar-item-apply">
          {{ '#CORE_FILTER.APPLY' | translate }}
        </soft-ds-button>
      </div>
    </div>
  </soft-menu-bar-dropdown>
  }
}

<soft-menu-bar-button [label]="'#CORE_FILTER.MENU_BAR.RESET' | translate"
                      [variant]="'plain'"
                      (execute)="reset()"
                      data-testid="filter-menu-bar-reset" />
<soft-menu-bar-button [label]="'#CORE_FILTER.MENU_BAR.FILTER' | translate"
                      icon="fa-regular fa-filter"
                      [variant]="'outline'"
                      [responsive]="true"
                      (execute)="openPageFilter()"
                      data-testid="filter-menu-bar-open" />
